module.exports = __webpack_public_path__ + "img/product-preview-43.91e301d.png";